// @ts-check
import React from 'react';
import { StandardHeader } from '~/components/StandardHeader';

/**
 * @template {{}} [TData={}] The shape of the data passed into gatsby's data-field (graphql usually)
 * @typedef {object} HeadWrapperOptions
 * @property {string[]} [onlyOnUrls=[]] A list of urls to use as a Whitelist for given children.
 * @property {Partial<TData>} [overrides={}] Optional fields to override on our standard header options.
 * @property {import('~/types/React').ReactFC<import('gatsby').HeadProps<TData>>} [AdditionalHeadContent]
 */

/**
 * @template {import('~/templates/page').CSPageData} [TData=import('~/templates/page').CSPageData] The shape of the data passed into gatsby's data-field (graphql usually)
 * @type {(options: HeadWrapperOptions<TData>) => import('~/types/React').ReactFC<import('gatsby').HeadProps<TData>>} HeadWrapperProps
 */
export const getHeadWrapper = (props) => {
	const { AdditionalHeadContent, onlyOnUrls = [], overrides = {} } = props;

	/** @type {ReturnType<typeof getHeadWrapper>} */
	return (gatsbyProps) => {
		const { children, location } = gatsbyProps;

		const title = gatsbyProps.data?.ozkPage?.page_title;
		const seo = gatsbyProps.data?.ozkPage?.seo;

		const csHeaderDefinitions = {
			title,
			meta: [
				{
					name: 'meta_title',
					content: seo?.meta_title,
				},
				{
					name: 'description',
					content: seo?.description,
				},
				{
					name: 'keywords',
					content: seo?.keywords,
				},
			],
		};

		// Detect if we should care about urls.
		let canRender = true;
		if (!!onlyOnUrls?.length && !!location.pathname) {
			canRender = onlyOnUrls.includes(location.pathname);
		}
		const updatedHeaderOptions = Object.assign({}, csHeaderDefinitions, overrides);

		return (
			<StandardHeader options={updatedHeaderOptions}>
				{/* Omit the children if we have a matching URL, otherwise attach. */}
				{!!canRender && children}

				{/* Add the additional header content if present */}
				{!!canRender && !!AdditionalHeadContent && <AdditionalHeadContent {...gatsbyProps} />}
			</StandardHeader>
		);
	};
};
